import React, { createContext, useContext } from 'react';
import { useGlobalContext } from './GlobalContext';
import { AuthContextType } from '../types';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { userData } = useGlobalContext();

  // Transform Mirats user data to our UserData interface
  const transformedUser = userData ? {
    name: userData.firstName && userData.lastName 
      ? `${userData.firstName} ${userData.lastName}`
      : userData.firstName || userData.email || 'User',
    email: userData.email || '',
    gasUserId: userData._id || userData.gasUserId || '',
  } : null;

  console.log('AuthContext: userData from GlobalContext:', userData);
  console.log('AuthContext: transformedUser:', transformedUser);

  const logout = () => {
    window.location.href = 'http://accounts.miratsgroup.com/logout?redirect=https%3A%2F%2Fchesshub.mirats.app';
    // TODO: Implement proper signOut from Mirats Auth
    console.log('Logout functionality to be implemented');
  };

  const login = () => {
    // This will be handled by ProtectRoute component
    console.log('Login should be handled by Mirats Auth');
  };

  const value: AuthContextType = {
    user: transformedUser,
    isAuthenticated: !!userData,
    isLoading: false, // We'll handle loading in ProtectRoute
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 